module.exports = __webpack_public_path__ + "static/media/Header-Logo-Mundial-white.0835eec4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Header-Logo-Mundial-white.png
// module id = 719
// module chunks = 0